import { render, staticRenderFns } from "./ConfirmationSentSection.vue?vue&type=template&id=4b3df249&scoped=true"
import script from "./ConfirmationSentSection.vue?vue&type=script&lang=ts"
export * from "./ConfirmationSentSection.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmationSentSection.vue?vue&type=style&index=0&id=4b3df249&prod&lang=scss&scoped=true"
import style1 from "./ConfirmationSentSection.vue?vue&type=style&index=1&id=4b3df249&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3df249",
  null
  
)

export default component.exports